import {createTippy} from '../modules/tippy.ts';

const storageKey = 'repo-sidebar-collapsed';
// Below this width the sidebar stays collapsed, so pages with their own side column keep their
// width. The inline script in templates/repo/header.tmpl and sidebar.css use the same width.
const narrowQuery = '(max-width: 1199.98px)';

export function initRepoSidebar(): void {
  const sidebar = document.querySelector<HTMLElement>('.repo-sidebar');
  if (!sidebar) return;
  const toggle = sidebar.querySelector<HTMLButtonElement>('.repo-sidebar-toggle')!;

  // The header can change height after load, for example when fonts load or the window narrows.
  const header = sidebar.previousElementSibling as HTMLElement;
  new ResizeObserver(() => {
    sidebar.style.setProperty('--repo-header-height', `${header.offsetHeight}px`);
  }).observe(header);

  new IntersectionObserver(([entry]) => {
    sidebar.classList.toggle('header-hidden', !entry.isIntersecting);
  }).observe(header);

  const toggleTooltip = createTippy(toggle, {placement: 'right', role: 'tooltip'});
  const sync = () => {
    const collapsed = sidebar.classList.contains('collapsed');
    const label = collapsed ? toggle.getAttribute('data-label-expand') : toggle.getAttribute('data-label-collapse');
    toggle.setAttribute('aria-expanded', String(!collapsed));
    toggle.setAttribute('aria-label', label);
    toggleTooltip.setContent(label);
  };
  sync();

  let userCollapsed = false;
  try {
    userCollapsed = localStorage.getItem(storageKey) === 'true';
  } catch {}
  const narrow = window.matchMedia(narrowQuery);
  const apply = () => {
    sidebar.classList.toggle('collapsed', userCollapsed || narrow.matches);
    sync();
  };
  narrow.addEventListener('change', apply);

  toggle.addEventListener('click', () => {
    userCollapsed = !sidebar.classList.contains('collapsed');
    try {
      localStorage.setItem(storageKey, String(userCollapsed));
    } catch {}
    apply();
  });

  // Labels are hidden when collapsed, so show them as tooltips only in that state.
  for (const item of sidebar.querySelectorAll<HTMLElement>('.item')) {
    const label = item.querySelector('.repo-nav-label')?.textContent.trim();
    if (!label) continue;
    createTippy(item, {
      content: label,
      placement: 'right',
      role: 'tooltip',
      onShow: () => (sidebar.classList.contains('collapsed') ? undefined : false),
    });
  }
}
